import React from 'react';
import { noop } from 'lodash';
import { ArrowRightIcon } from '@fiverr-private/visuals';
import { Button } from '@fiverr-private/button';
import { Text } from '@fiverr-private/typography';
import { Box } from '@fiverr-private/theme';
import { ResponsiveIcon } from '../ResponsiveIcon/ResponsiveIcon';

interface ContactSellerOptionProps {
  title: string;
  titleExt?: string;
  subtitle?: string;
  IconComponent: React.ReactNode;
  loading?: boolean;
  onClick?: () => void;
}

export const ContactSellerOption: React.FC<ContactSellerOptionProps> = ({
  title,
  titleExt,
  subtitle,
  IconComponent,
  loading = false,
  onClick = noop,
  ...props
}) => (
  <Button variant="ghost" loading={loading} onClick={onClick} {...props} fullWidth size={{ default: 'sm', sm: 'md' }}>
    <Box
      display="grid"
      columnGap={{ default: '3', sm: '4' }}
      width="100%"
      textAlign="start"
      style={{
        gridTemplateColumns: 'auto 1fr auto',
        gridTemplateRows: subtitle ? 'auto auto' : 'auto',
      }}
      alignItems="center"
    >
      <Box
        width={{ default: '24px', sm: '42px' }}
        height={{ default: '24px', sm: '42px' }}
        borderRadius="circle"
        backgroundColor="grey_300"
        justifyContent="center"
        display="flex"
        alignItems="center"
        columnStart="1"
        columnEnd="2"
        rowStart="1"
        rowEnd={subtitle ? '3' : '2'}
        alignSelf={{ default: 'flexStart', sm: 'center' }}
      >
        <Box display="flex">{IconComponent}</Box>
      </Box>
      <Box columnStart="2" columnEnd="3" overflow="hidden">
        <Text size={{ default: 'b_sm', sm: 'b_md' }} fontWeight="semibold" overflow="hidden" textOverflow="ellipsis">
          {title}
        </Text>
      </Box>

      {!!subtitle && (
        <Box columnStart="2" columnEnd={{ default: '4', sm: '3' }}>
          <Text size={{ default: 'b_xs', sm: 'b_sm' }} color="bodySecondary" whiteSpace="preWrap" textAlign="start">
            {subtitle}
          </Text>
        </Box>
      )}
      <Box
        display="flex"
        gap="2"
        alignItems="center"
        columnStart="3"
        columnEnd="4"
        rowStart="1"
        rowEnd={{ default: '2', sm: subtitle ? '3' : '2' }}
      >
        {!!titleExt && (
          <Text size="b_sm" fontWeight="semibold">
            {titleExt}
          </Text>
        )}
        <ResponsiveIcon Icon={ArrowRightIcon} />
      </Box>
    </Box>
  </Button>
);
